export default "__VITE_PUBLIC_ASSET__094a8bac__"